import ServiceConfig from "service.config.js";
import { versionedHttpCollection } from "us.helper/http/collection";

export default {
  postalAreas: {
    get: async <P extends {} | {}[]>(params: P): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.get(
            "entityservice",
            "postalCodes",
            {},
            ServiceConfig()[`entityservice`][`postalCodes`]
          );
          if (status === 200 || status === 204) {
            resolve({ data, status });
          } else {
            reject(data);
          }
        } catch (error) {
          reject(error);
        }
      });
    },
    save: (params: any): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data } = await versionedHttpCollection.post(
            "entityservice",
            `entities/postalCodes`,
            params,
            ServiceConfig()[`entityservice`][`entities.postalCode`]
          );
          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
    delete: (params: { postalcodeId: number }): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { postalcodeId } = params;
          const { data, status } = await versionedHttpCollection.delete(
            "entityservice",
            `entities/Postalcodes`,
            `${postalcodeId}`,
            {},
            ServiceConfig()[`entityservice`][`postalCodes`]
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
